module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-cyrillic241.606a0f5.woff2";